import { css, html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { when } from "lit/directives/when.js";
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement("se-edit-form-card")
export class SeEditFormCardElement extends LitElement {
    @property({ type: String }) cardTitle = "";
    @property({ type: Boolean, reflect: true }) collapsed = false;
    @property({ type: Boolean }) collapsible = false;

    @state() private _isCollapsed = false;

    connectedCallback() {
        super.connectedCallback();
        this._isCollapsed = this.collapsible && this.collapsed;
    }

    private _toggleCollapse() {
        if (!this.collapsible) return;
        this._isCollapsed = !this._isCollapsed;
        this.dispatchEvent(new CustomEvent('toggle-collapse', { detail: { collapsed: this._isCollapsed }, bubbles: true, composed: true }));
    }

    render() {
        const iconClass = this._isCollapsed ? "fa-chevron-down" : "fa-chevron-up";
        const clickHandler = this.collapsible ? this._toggleCollapse : undefined;

        return html`
            <div class="card-container ${this._isCollapsed ? 'collapsed' : ''} ${this.collapsible ? 'collapsible' : ''}">
                <div class="h3 ${this.collapsible ? 'collapsible-header' : ''}" @click=${ifDefined(clickHandler)}>
                     <span>${this.cardTitle}</span>
                     ${when(this.collapsible, () => html`<fa-icon fa-class="fas ${iconClass}"></fa-icon>`)}
                </div>
                ${when(!this.collapsible || !this._isCollapsed, () => html`
                    <div class="scroll-container">
                        <slot></slot>
                    </div>
                `)}
            </div>
        `;
    }

    static styles = css`
        :host {
            display: block;
        }
        .card-container {
             border: 1px solid var(--color-gray-4);
             border-radius: 5px;
             overflow: hidden;
             background-color: var(--color-light);
             transition: all 0.3s ease-out;
             max-width: 1000px;
        }

        .h3 {
            font: var(--font-h3);
            background: var(--color-blue-25);
            padding: 10px;
            font-size: 12px;
            font-weight: 600;
            text-transform: uppercase;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .h3.collapsible-header {
            cursor: pointer;
            user-select: none;
        }
        .h3.collapsible-header:hover {
             background-color: var(--color-gray-2);
        }
        .h3:not(.collapsible-header) {
             justify-content: flex-start;
        }

        .scroll-container {
            overflow: auto;
            background-color: white;
            box-sizing: border-box;
            padding: 10px;
            border-top: 1px solid var(--color-gray-4);
        }
    `;
} 